import Pricingnorm from '../../../assets/images/pricing.png';
import Listicon from '../../../assets/images/listicon.svg';
import { useNavigate } from 'react-router-dom';

function New ({ plans }) {

  const goTo = useNavigate();

  return (
    <>

      <div className="pricingbtns ">
        <ul>
          <li><a className="btn-primary" href="#">Monthly</a> </li>
          <li><a className="btn-tertiary" href="#">Yearly</a> </li>
        </ul>
      </div>


      <div className="container-pricing " id="pricing">

        <div className="row py-600">
          {plans.map(plan => (

            <div className="col-12 col-lg-3 p-150">
              <div className="pricing relative h-full bc-grayish-lavender p-300 pb-1200">

                <img className="pricingimg" src={Pricingnorm} alt="" />

                <h2 className="fs-300 px-200 fs-300 lh-300 mb-200">{plan.name}</h2>

                <h1 className="fs-800 lh-800 px-200 mb-200">₹{Math.trunc(plan.price)}</h1>

                <h3 className="px-200 fs-200 lh-200 mb-200">{plan.noOfEntries} Free entries</h3>

                <div className='pricingfeatures'>
                  {plan.features.map(feature => {
                    return (<p className="pl-400 relative mb-100"> <img src={Listicon} alt="" className="s-300 absolute l-0 t-0" /> {feature} </p>)
                  })}

                </div>
                <a className="btn-primary absolute l-300 b-300" onClick={() => {
                  if (localStorage.getItem('token')) {
                    const role = localStorage.getItem('role');
                    goTo(role === 'partner' ? '/partner/verify' : '/dashboard/my-subscription');
                    return;
                  }
                  goTo('/SignUp', { state: { id: plan.id } });
                }}>Subscribe Now</a>

              </div>

            </div>

          ))}

        </div>
      </div>


    </>
  );
}

export default New;